import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { environment } from '../../../../../environments/environment';
import { ReturnStruct } from '../../structs/return.struct';
import { ConfigPessoaRequest } from '../../requests/pessoa/config-pessoa.request';
import { ConfigPessoaResponse } from '../../responses/pessoa/config-pessoa.response';

@Injectable({
  providedIn: 'root',
})
export class ConfigPessoaService extends CommonService {
  constructor(
    private httpClient: HttpClient
  ) {
    super();
  }

  // Controller: [HttpGet]
  public get(): Observable<ConfigPessoaResponse> {
    return this.httpClient
      .get<ConfigPessoaResponse>(
        environment.urlApiPessoa + `ConfigPessoa`,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }

  // Controller: [HttpGet("lookup")]
  public getLookup(): Observable<ConfigPessoaResponse> {
    return this.httpClient
      .get<ConfigPessoaResponse>(
        environment.urlApiPessoa + `ConfigPessoa/lookup`,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }

  // Controller: [HttpPut("idConfigPessoa/{idConfigPessoa}")]
  public put(idConfigPessoa: number, request: ConfigPessoaRequest): Observable<ReturnStruct> {
    return this.httpClient
      .put<ReturnStruct>(
        environment.urlApiPessoa + `ConfigPessoa/idConfigPessoa/${idConfigPessoa}`,
        request,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }
}